import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { HeaderName } from '../../constants/header-name.enum';

@Injectable({
    providedIn: 'root'
})
export class OngoingRequestTrackerService {
    private readonly requestInProgress$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private requestCount = 0;

    constructor() {
    }

    trackRequestStarted(): void {
        this.requestCount++;
        if (this.requestCount === 1) {
            this.requestInProgress$.next(true);
        }
    }

    trackRequestDone(): void {
        if (this.requestCount > 0) {
            this.requestCount--;

            if (this.requestCount === 0) {
                this.requestInProgress$.next(false);
            }
        }
    }

    isInProgress(): Observable<boolean> {
        return this.requestInProgress$.asObservable();
    }

    createTrackingEnabledRequestOptions(): { headers: HttpHeaders } {
        const httpHeaders = new HttpHeaders().set(HeaderName.IsBackgroundRequest, 'true');

        return { headers: httpHeaders };
    }
}
